import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { UserInfo } from '../shared/user-info.model';
import { DisplayMode } from '../../shared/display-mode';
import { UserService } from '../shared/user.service';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from '../../shared/services/loader.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ComponentCanDeactivate } from '../../core/guards/pending-changes.guard';
import { UserFormComponent } from '../user-form/user-form.component';
import { NavigationService } from '../../shared/services/navigation.service';
import {finalize, switchMap, tap} from 'rxjs/operators';
import { RegionService } from '../shared/region.service';
import { Region } from '../shared/region.model';
import {BluechatService} from '../../bluechat/bluechat.service';
import {BluechatUserCreation} from '../../bluechat/models/BluechatUserCreation';
import {ModalService} from '../../shared/services/modal.service';
import {BluechatAgentCreation} from '../../bluechat/models/BluechatAgentCreation';
import {ErrorHandlerService} from '../../shared/services/error-handler.service';
import { UserInfoWithNames } from '../user-table/user-table.component';

@Component({
  selector: 'app-chep-manager-form',
  templateUrl: './chep-manager-form.component.html',
  styleUrls: ['./chep-manager-form.component.scss']
})
export class ChepManagerFormComponent implements OnInit, ComponentCanDeactivate {

  user: UserInfo = new UserInfo();

  regions: Region[] = [];

  onCreate: (u: UserInfo) => Observable<UserInfo>;
  onUpdate: (u: UserInfo) => Observable<UserInfo>;
  onDelete: (u: UserInfo) => Observable<boolean>;
  onToggleBlocking: (u: UserInfo) => Observable<boolean>;
  onUnblockIp: (u: UserInfo) => Observable<boolean>;

  mode = DisplayMode.Creation;

  DisplayMode = DisplayMode;

  formTitle = 'New CHEP Manager';

  @ViewChild('userForm')
  userFormComponent: UserFormComponent;

  constructor(
    private route: ActivatedRoute,
    private navigation: NavigationService,
    private userService: UserService,
    private regionService: RegionService,
    private loader: LoaderService,
    private bluechatService: BluechatService,
    private toastr: ToastrService,
    private modalService: ModalService,
    private errorHandler: ErrorHandlerService
  ) {
    this.onCreate         = u => this.userService.createChepManager(u);
    this.onUpdate         = u => this.userService.updateChepManager(u);
    this.onDelete         = u => this.userService.deleteChepManager(u.id);
    this.onToggleBlocking = u => this.userService.toggleBlockingChepManager(u);
    this.onUnblockIp      = u => this.userService.unblockIpChepManager(u);
  }

  ngOnInit() {
    this.regionService.getAllLight().subscribe(regions => {
      this.regions = regions;
      this.route.queryParamMap.subscribe(params => {
        this.user.allowedRegions = params.getAll('allowedRegions');
      });
    });

    this.route.params.subscribe(params => {
      const chepManagerId = params.id;

      if (!!chepManagerId) {
        this.loader.startLoad(false);

        this.userService.getById(chepManagerId)
          .pipe(finalize(() => this.loader.stopLoad()))
          .subscribe(chepManager => {
            this.user = chepManager;
            this.switchToUpdateMode();
          }, (error: HttpErrorResponse) => {
            console.log(error);
            this.toastr.error(`An error occured while fetching the chep manager`, 'Error');
          });
      }
    });
  }

  getForm() {
    return this.userFormComponent.form;
  }

  switchToUpdateMode(): void {
    this.mode      = DisplayMode.Edition;
    this.formTitle = 'CHEP Manager Edition';
  }

  goToChepManagerList() {
    this.navigation.chepManagers()
      .list()
      .go();
  }

  changePassword(password: string) {
    this.loader.startLoad();
    this.userService.updatePassword(this.user, password)
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe(() => {
        this.toastr.success('The password has been successfully updated', 'Success');
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error(error.error.message || 'Error while updating the password', 'Error');
      });
  }

  enableBluechat(userDetails: UserInfoWithNames) {
    const bluechatAgentCreation = this.createBluechatAgentCreationRequest(userDetails);

    this.loader.startLoad();
    this.bluechatService.enableBluechatOnChepManager(
      userDetails.user.id,
      bluechatAgentCreation
    ).pipe(
      finalize(() => this.loader.stopLoad()),
    ).subscribe(user => {
      this.toastr.success(`${user.email} linked to Bluechat`);
      this.user = user;
    }, err => {
      this.errorHandler.handleHttpError(err)
    });
  }

  private createBluechatAgentCreationRequest(userInfo: UserInfoWithNames): BluechatAgentCreation {
    return {
      firstname: userInfo.firstname,
      lastname: userInfo.lastname,
      email: userInfo.user.email,
    };
  }
}
